<template>
    <div>
        <navigation-bar Close/>
        <div class="customerService main">

            <div v-for="(item, index) in dataList" :key="index">
                <p :class=" item.categoryName !== '' ? 'strongTitle': '' ">{{ item.categoryName }}</p>
                <el-collapse accordion class="listGroup">
                    <el-collapse-item
                        v-for="(dataItem, index) in item.data"
                        :key="index"
                        class="listItem">
                        <div class="list-title" slot="title">{{ dataItem.question }}</div>
                        <div class="list-content" v-html="dataItem.ask"/>
                    </el-collapse-item>
                </el-collapse>
            </div>


            <loading
                    :active.sync=isLoading
                    :can-cancel="false"
                    :is-full-page="true">
            </loading>
        </div>
    </div>
</template>

<script>

    import {notNull} from "@/util/common";

    export default {
        name: "Question",
        data() {
            return {
                isLoading: false,
                storeId: this.$route.params.storeId,
                dataList: [],
            };
        },
        created() {
            if (notNull(this.storeId)) {
                this.setup();
            }
        },
        mounted() {
        },
        methods: {
            setup() {
                this.isLoading = true;

                this.$http.fetch`QuestionAndAskList${{
                    'storeId': Number(this.storeId)
                }}
                ${json => {
                    if (notNull(json.data)) {
                        this.dataList = json.data;
                    }
                    this.isLoading = false;
                }}`;
            }
        },
    };
</script>

<style lang="less" scoped src="@/less/service.less"/>
<style lang="less" scoped>
    .customerService .strongTitle{
        border: 2px dashed var(--color-yellow);
        border-radius: 12px;
        margin: 0 20px;
        font-size: 18px;
        padding: 6px 0;
    }
    .listGroup{
        box-shadow: none;
    }
    .listItem .el-collapse-item__header > .list-title::before{
        width: 8px;
        height: 8px;
        border-radius: 50%;
    }
</style>